<div *ngIf="zone === 'onboarding'" class="col m-0" [ngStyle]="contentStyle">
  <div
    class="widget-wrapper"
    [ngClass]="isStepComplete ? 'step-complete' : isError ? 'error' : 'open'"
    [ngStyle]="borderStyle"
    style="min-height: 100%"
  >
    <div *ngIf="widgetConfig.attributes['sub_heading']" class="title-wrapper">
      <div class="title">
        <p [ngStyle]="colorTextAlignStyle" class="subtitle">
          <span>{{ widgetConfig.attributes['sub_heading'] }}</span>
        </p>
      </div>
      <div class="steps-count-wrapper">
        <div>
          <img
            *ngIf="!isError && emailForm.valid && isEmailShowSuccessIcon"
            src="assets/images/check-circle.svg"
            alt="check-circle"
            class="img-fluid"
          />
          <img
            *ngIf="!isStepComplete && isError && isEmailShowErrorIcon"
            (click)="showErrorMsg()"
            src="assets/images/exclamation-circle.svg"
            alt="check-circle"
            class="cursor-pointer img-fluid"
          />
        </div>
      </div>
      <div *ngIf="!isStepComplete && isError && isShowErrorMsg" class="error-msg">
        <img src="assets/images/exclamation-circle.svg" alt="check-circle" class="img-fluid" />
        <label>Email Restriction</label>
        <p>{{ errorMsg }}</p>
      </div>
    </div>
    <div class="form-wrapper">
      <form [formGroup]="emailForm">
        <div class="form-group" *ngFor="let field of widgetConfig.attributes['field_attributes']">
          <ng-container *ngIf="field.type !== 'dropdown'">
            <div class="p-inputgroup background-transparent position-relative">
              <finx-input
                type="email"
                [formControlName]="field.name"
                [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
                [label]="field.label"
                [formGroup]="emailForm"
                [value]="emailForm.get(field.name)?.value"
                [textColor]="colorStyle"
                [colorTextAlignStyle]="colorTextAlignStyle"
                [textInputFontStyle]="textInputFontStyle"
                [textInputBackgroundColor]="textInputBackgroundColor"
                (change)="onChangeEmailInput()"
                (keyup)="valueChangesTrigger()"
                (focusEvent)="updateCurrentStyles($event)"
                [inputStyle]="currentInputStyle"
                (valueChange)="emailInputChange()"
                [ngClass]="{ 'finx-input-with-padding': showConfirmBtn }"
              ></finx-input>
              <div class="verification-block">
                <finx-button
                  [buttonStyle]="!isAllowedGlobalStyling ? verifyButtonStyle : {}"
                  *ngIf="showConfirmBtn || isWorkflow"
                  type="button"
                  class="verify-button btn-small btn-position-styling"
                  [ngClass]="{ 'pointer-events-none': isWorkflow }"
                  [class]="isAllowedGlobalStyling ? globalStylingClass : ''"
                  [labeltext]="verifyButtonTextContent ?? 'Verify'"
                  (click)="verifyEmail()"
                ></finx-button>
              </div>
            </div>
          </ng-container>
          <div
            class="text-error"
            *ngIf="emailForm.get(field.name)?.touched && emailForm.get(field.name)?.invalid"
          >
            <p class="m-0" *ngIf="!email">
              {{ sanitizeFieldLabel(field.label) || 'Email' }} is a required field
            </p>
            <p class="m-0" *ngIf="email">
              Please enter a valid
              {{ sanitizeFieldLabel(field.label) || 'Email' }}
            </p>
          </div>
          <div
            class="text-error"
            *ngIf="isAnyFieldRequired && emailForm.get('email')?.valid && !isStepComplete"
          >
            <p class="m-0">Email needs validation before proceeding to the next step.</p>
          </div>
        </div>
        <div
          class="form-group m-0 is-hidden"
          style="position: fixed; bottom: 1em; left: 1em; width: calc(100% - 2em)"
        >
          <finx-button
            type="button"
            class="btn w-100 mt-2"
            labeltext="Confirm"
            (click)="onSubmit()"
          ></finx-button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- profile desgin -->
<div
  *ngIf="zone !== 'onboarding'"
  class="col element-zoom profile-page"
  [ngStyle]="combinedContentAndBorderStyles"
  style="height: 100%"
>
  <div class="form-wrapper" style="height: 100%">
    <form [formGroup]="emailForm" style="height: 100%">
      <div class="form-group" *ngFor="let field of fieldAttributes">
        <ng-container *ngIf="field.type !== 'dropdown'">
          <div class="p-inputgroup background-transparent position-relative">
            <finx-input
              [textColor]="colorStyle"
              type="email"
              email="true"
              className="no-increment-input"
              [(ngModel)]="email"
              [formControlName]="field.name"
              [label]="field.label"
              placeholder="abc123@email.com"
              [readOnly]="isFieldDisabled"
              [value]="emailForm.get('email')?.value ?? ''"
              (change)="verifiedEmailChanged()"
              (keyup)="valueChangesTrigger()"
              [colorTextAlignStyle]="colorTextAlignStyle"
              [textInputFontStyle]="textInputFontStyle"
              [textInputBackgroundColor]="textInputBackgroundColor"
              [inputStyle]="currentInputStyle"
              [labelAsPlaceholder]="pageConfig?.labelsAsPlaceholder"
              (focusEvent)="updateCurrentStyles($event)"
              (valueChange)="emailInputChange()"
              [ngClass]="{ 'finx-input-with-padding': showConfirmBtn }"
            ></finx-input>
            <div class="verification-block">
              <finx-button
                [buttonStyle]="!isAllowedGlobalStyling ? verifyButtonStyle : {}"
                *ngIf="showConfirmBtn || isWorkflow"
                type="button"
                class="verify-button btn-small d-flex"
                [ngClass]="{ 'pointer-events-none': isWorkflow }"
                [class]="isAllowedGlobalStyling ? globalStylingClass : ''"
                [labeltext]="verifyButtonTextContent ?? 'Verify'"
                (click)="verifyEmail()"
              ></finx-button>
              <span *ngIf="showWaitingIcon" class="d-block">
                <img
                  (click)="showErrorMsg()"
                  src="assets/images/clock-blue.svg"
                  alt="check-circle"
                  class="cursor-pointer img-fluid"
                />
              </span>
            </div>
          </div>

          <div
            class="text-error"
            *ngIf="emailForm.get(field.name)?.touched && emailForm.get(field.name)?.invalid"
          >
            <p class="m-0" *ngIf="!email">{{ field.label || 'Email' }} is a required field</p>
            <p class="m-0" *ngIf="email">Please enter a valid {{ field.label || 'Email' }}</p>
          </div>
          @if (isEmailVerificationEnabled && emailForm.get('isEmailVerified')?.invalid &&
          emailForm.get('email')?.valid && !isOldEmail) {
          <div class="text-error">
            <p class="m-0">Please verify your email</p>
          </div>
          }
        </ng-container>
      </div>
      <div class="form-group is-center" *ngIf="isAnyFieldRequired">
        <span>
          <img src="assets/images/exclamation-circle-gray.svg" alt="check-circle" class="img-fluid"
        /></span>
        <span class="validation-need-text"> Email needs validation before proceeding to the next step.</span>
      </div>
    </form>
  </div>
</div>
